import request from '@/utils/request'
export function saveVehicleInformation(data) {
    return request({
        url:`/api/Vehicle/saveVehicleInformation`,
        method:'post',
        data:data
    })
}

export function getVehicleInformationByTime(LicensePlate,StartTime,EndTime) {
    return request({
        url:`/api/Vehicle/getVehicleInformationByTime?LicensePlate=${LicensePlate}&StartTime=${StartTime}&EndTime=${EndTime}`,
        method:'get',
    })
}